import { Injectable } from '@angular/core';
import type { LocalStorageKey } from './local-storage-keys';

/**
 * Wrapper around localStorage for persisting key-value data in the browser.
 * Use this instead of accessing localStorage directly. Keys are typed via
 * {@link LocalStorageKey} (context.domain.property) so available values are
 * discoverable and consistent.
 */
@Injectable({ providedIn: 'root' })
export class LocalStorageService {
	getItem(key: LocalStorageKey): string | null {
		if (typeof localStorage === 'undefined') return null;
		return localStorage.getItem(key);
	}

	setItem(key: LocalStorageKey, value: string): void {
		if (typeof localStorage === 'undefined') return;
		localStorage.setItem(key, value);
	}

	removeItem(key: LocalStorageKey): void {
		if (typeof localStorage === 'undefined') return;
		localStorage.removeItem(key);
	}
}
